if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          nativeShareButton: this.querySelector('[data-native-share-button]'),
          shareSummary: this.querySelector('summary'),
          closeButtons: this.querySelectorAll('[data-share-close]'),
          copyButton: this.querySelector('[data-share-copy]'),
          successMessage: this.querySelector('[data-share-message]'),
          urlInput: this.querySelector('[data-share-url]')
        };

        this.urlToShare = this.elements.urlInput
          ? this.elements.urlInput.value
          : document.location.href;

        this.onKeyup = this.onKeyup.bind(this);

        const isMobileDevice = this.isMobileDevice();

        /**
         * Mobile devices:
         * Use native share if supported.
         *
         * Desktop, including macOS:
         * Always use custom modal.
         */
        if (navigator.share && isMobileDevice && this.elements.nativeShareButton) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.nativeShareButton.classList.remove('hidden');

          this.elements.nativeShareButton.addEventListener('click', this.openNativeShare.bind(this));

          return;
        }

        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));

        this.elements.copyButton?.addEventListener('click', this.copyToClipboard.bind(this));

        this.elements.closeButtons.forEach((button) => {
          button.addEventListener('click', this.close.bind(this));
        });
      }

      isMobileDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      }

      openNativeShare(event) {
        event.preventDefault();

        navigator.share({
          url: this.urlToShare,
          title: document.title,
          text: document.querySelector('meta[property="og:description"]')?.content || ''
        });
      }

      toggleDetails() {
        const isOpen = this.mainDetailsToggle.open;

        document.documentElement.classList.toggle('share-modal-is-open', isOpen);

        if (this.elements.shareSummary) {
          this.elements.shareSummary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }

        if (isOpen) {
          document.addEventListener('keyup', this.onKeyup);
          return;
        }

        document.removeEventListener('keyup', this.onKeyup);
        this.resetMessage();
      }

      close(event) {
        event?.preventDefault();

        this.mainDetailsToggle.removeAttribute('open');
        document.documentElement.classList.remove('share-modal-is-open');
        document.removeEventListener('keyup', this.onKeyup);

        if (this.elements.shareSummary) {
          this.elements.shareSummary.setAttribute('aria-expanded', 'false');
          this.elements.shareSummary.focus();
        }

        this.resetMessage();
      }

      onKeyup(event) {
        if (event.key === 'Escape') {
          this.close(event);
        }
      }

      onFocusOut() {}

      async copyToClipboard(event) {
        console.log('it works');
        event?.preventDefault();

        if (!this.elements.urlInput) return;

        const url = this.elements.urlInput.value;

        try {
          await navigator.clipboard.writeText(url);
        } catch (error) {
          this.elements.urlInput.select();
          document.execCommand('copy');
        }

        this.showMessage();
      }

      showMessage() {
        if (!this.elements.successMessage) return;

        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.hidden = false;
        this.elements.successMessage.textContent =
          window.accessibilityStrings?.shareSuccess || 'Link copied';

        window.setTimeout(() => {
          this.resetMessage();
        }, 2500);
      }

      resetMessage() {
        if (!this.elements.successMessage) return;

        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.hidden = true;
        this.elements.successMessage.textContent = '';
      }

      updateUrl(url) {
        this.urlToShare = url;

        if (this.elements.urlInput) {
          this.elements.urlInput.value = url;
        }
      }
    }
  );
}